import { render, staticRenderFns } from "./ContactSupportModal.vue?vue&type=template&id=2bc4571f&scoped=true&"
import script from "./ContactSupportModal.vue?vue&type=script&lang=ts&"
export * from "./ContactSupportModal.vue?vue&type=script&lang=ts&"
import style0 from "./ContactSupportModal.vue?vue&type=style&index=0&id=2bc4571f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4571f",
  null
  
)

export default component.exports